// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const DocumentCodeIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "DocumentCode/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.333 1.667H6.667C3.75 1.667 2.5 3.333 2.5 5.833v8.334c0 2.5 1.25 4.166 4.167 4.166h6.666c2.917 0 4.167-1.666 4.167-4.166V5.833c0-2.5-1.25-4.166-4.167-4.166ZM8.775 13.725a.629.629 0 0 1 0 .883.618.618 0 0 1-.442.184.618.618 0 0 1-.441-.184l-1.667-1.666a.629.629 0 0 1 0-.884l1.667-1.666a.629.629 0 0 1 .883 0 .629.629 0 0 1 0 .883L7.55 12.5l1.225 1.225Zm5-.783-1.667 1.666a.618.618 0 0 1-.441.184.618.618 0 0 1-.442-.184.629.629 0 0 1 0-.883L12.45 12.5l-1.225-1.225a.629.629 0 0 1 0-.883.629.629 0 0 1 .883 0l1.667 1.666a.629.629 0 0 1 0 .884Zm1.642-5.234H13.75a2.29 2.29 0 0 1-2.292-2.291V3.75a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v1.667c0 .575.467 1.041 1.042 1.041h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default DocumentCodeIcon;